import { ReactNode } from 'react'
import { Body1, Headline1, Headline2, Headline3 } from '../Typography/Text'
import styled from 'styled-components'
import NextImage from 'components/elements/NextImage'
import theme from 'stories/utils/theme'

const Container = styled.div<{ isInverted?: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .row {
        display: flex;
        flex-direction: ${({ isInverted }) => (isInverted ? 'row-reverse' : 'row')};
        align-items: center;
        justify-content: center;
        gap: 20px;
        .texts {
            display: flex;
            flex-direction: column;
            justify-content: left;
            align-items: left;
            width: 65%;
            gap: 15px;
        }
    }
    @media (max-width: 1050px) {
        .row {
            flex-direction: column-reverse;
        }
        .texts {
            width: 100%;
            justify-content: center;
            align-items: center;
            * {
                text-align: center;
            }
        }
    }
`

interface Props {
    headline: string
    subtitle: string
    text: string
    image: StaticImageData
    children?: ReactNode
    isInverted?: boolean
    isHeader?: boolean
}

const SmallFeatureGrid = ({ headline, subtitle, text, image, children, isInverted, isHeader }: Props) => {
    const Headline = isHeader ? Headline1 : Headline2

    return (
        <Container isInverted={isInverted}>
            <div className="row">
                <div className="texts">
                    <Headline fontFamily="var(--font-poppins)" fontSize={30} fontWeight={600} color={theme.colors.darkBlue}>
                        {headline}
                    </Headline>
                    <Headline3
                        fontFamily="var(--font-poppins)"
                        fontSize={24}
                        fontWeight={600}
                        color={theme.colors.contentPrimary}
                    >
                        {subtitle}
                    </Headline3>
                    <Body1 fontFamily="var(--font-inter)" fontSize={16} fontWeight={400} color={theme.colors.contentPrimary}>
                        {text}
                    </Body1>
                    {children}
                </div>
                <NextImage src={image.src} alt={headline} width={image.width} height={image.height} />
            </div>
        </Container>
    )
}

export default SmallFeatureGrid
